import {UI, type PartialOptions} from "../../stem-core/ui/UIBase";
import type {NodeAttributes} from "../../stem-core/ui/NodeAttributes";
import {StyleSheet, styleRule, registerStyle} from "../../stem-core/ui/Style";


class HorizontalLineStyle extends StyleSheet {
    @styleRule
    horizontalLine = {
        width: "100%",
        height: 2,
        background: this.themeProps.LANDING_PAGE_HORIZONTAL_LINE_COLOR,
    };
}

interface HorizontalLineOptions {
    marginTop?: number | string;
    marginBottom?: number | string;
}

@registerStyle(HorizontalLineStyle)
export class HorizontalLine extends UI.Element<HorizontalLineOptions> {
    getDefaultOptions(): PartialOptions<HorizontalLine> {
        return {
            ...super.getDefaultOptions(),
            marginTop: 0,
            marginBottom: 0,
        };
    }

    extraNodeAttributes(attr: NodeAttributes) {
        attr.addClass(this.styleSheet.horizontalLine);
        attr.setStyle({
            marginTop: this.options.marginTop,
            marginBottom: this.options.marginBottom,
        });
    }
}
